export default "__VITE_ASSET__CrgXDDNI__"